import { useMemo } from "react";
import {
  getLastArtifactId,
  SessionItem,
  SessionItemKind,
  SessionRenderingContext,
} from "../session-item";
import { SessionStatus, MDSSessionConfig } from "../session.types";
import { SessionViewMode } from "../session.constants";

export const useSessionRenderContext = ({
  sessionStatus,
  sessionViewMode,
  sessionItems,
  sessionConfig,
}: {
  sessionStatus: SessionStatus;
  sessionViewMode: SessionViewMode;
  sessionItems: SessionItem[];
  sessionConfig: MDSSessionConfig;
}): SessionRenderingContext => {
  const config = useMemo(
    () => ({
      openLinksInNewTab: sessionConfig.openLinksInNewTab,
      prohibitNativeCmdClick: sessionConfig.prohibitNativeCmdClick,
      linkHandler: sessionConfig.linkHandler,
      onMemItemOver: sessionConfig.onMemItemOver,
      onMemItemOut: sessionConfig.onMemItemOut,
      feedbackHandler: sessionConfig.feedbackHandler,
    }),
    [
      sessionConfig.openLinksInNewTab,
      sessionConfig.linkHandler,
      sessionConfig.onMemItemOver,
      sessionConfig.onMemItemOut,
      sessionConfig.feedbackHandler,
      sessionConfig.prohibitNativeCmdClick,
    ]
  );

  return useMemo(
    () => ({
      status: sessionStatus,
      sessionViewMode,
      config,
      lastReasoningGroupId: (() => {
        const last = sessionItems
          .slice()
          .reverse()
          .find(item => item.kind === SessionItemKind.ReasoningGroup);
        return last?.id ?? null;
      })(),
      lastItemId: sessionItems.length > 0 ? sessionItems[sessionItems.length - 1].id : null,
      lastArtifactId: getLastArtifactId(sessionItems),
    }),
    [sessionStatus, sessionViewMode, config, sessionItems]
  );
};
